import type { Die } from '../models/die.type';
import { DieFace } from '../models/face.type';
import type { Technique } from '../models/techniques.type';

/*
  A technique's slots, as the ledger hands them out: the die in each of its
  ingredients, or undefined. A die that fills two slots is in both.
*/
export type Slots = Array<Die | undefined>;

/** Whether a die is sitting in this slot. */
export function slotFilled(slots: Slots, index: number) {
  return !!slots[index];
}

/** Whether every ingredient of the technique has a die in it. */
export function techniqueFull(technique: Technique, slots: Slots) {
  return technique.ingredients.every(
    (ingredient, index) => ingredient === DieFace.OR || !!slots[index],
  );
}

/** Whether no slot has a die in it. */
export function slotsEmpty(slots: Slots) {
  return slots.every((die) => !die);
}

/**
 * The dice a technique is made with, one per filled ingredient -- what its
 * activate() is handed. A die that fills two slots is counted twice, as
 * Strength counts it.
 */
export function ingredientDice(slots: Slots): Array<Die> {
  return slots.filter((die): die is Die => !!die);
}

/** Each die in the slots once. */
export function diceInSlots(slots: Slots): Array<Die> {
  return [...new Set(ingredientDice(slots))];
}
